module.exports = __webpack_public_path__ + "img/1.ab79857a.png";